import { render, staticRenderFns } from "./PaymentClub.vue?vue&type=template&id=dc925a42&scoped=true&"
import script from "./PaymentClub.vue?vue&type=script&lang=ts&setup=true&"
export * from "./PaymentClub.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./PaymentClub.vue?vue&type=style&index=0&id=dc925a42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc925a42",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dc925a42')) {
      api.createRecord('dc925a42', component.options)
    } else {
      api.reload('dc925a42', component.options)
    }
    module.hot.accept("./PaymentClub.vue?vue&type=template&id=dc925a42&scoped=true&", function () {
      api.rerender('dc925a42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/appointment/vrach/new/components/DoctorAppointmentForm/components/PaymentInfo/components/PaymentClub/PaymentClub.vue"
export default component.exports